// Mock-данные прототипа — портировано из design_ref/src/data.jsx.
// Сейчас всё статично; постепенно вытесняем реальными вызовами API.

export type WellStatus = 'active' | 'warn' | 'err' | 'idle'

export type Well = {
  id: string
  name: string
  field: string
  status: WellStatus
  depth: number
  target: number
  op: string
  rop: number
  mud: number
  pressure: number
  updated: string
  note: string
}

export type Field = { name: string; count: number; color: string }

export type RecentItem = { id: string; title: string; kind: 'note' | 'incident' | 'file' }

export type ActivityItem = { time: string; who: string; what: string; target: string; well: string }

export type Task = {
  id: string
  title: string
  well: string
  due: string
  priority: 'high' | 'med' | 'low'
  done: boolean
}

export type FileItem = { name: string; kind: string; size: string; date: string; thumb: string }

export type SearchResult = { kind: 'well' | 'note' | 'file' | 'task'; title: string; snippet: string }

export const WELLS: Well[] = [
  { id: 'BR-217-04', name: 'Берёзовская 4', field: 'Берёзовское', status: 'active', depth: 3247, target: 3800, op: 'Бурение',  rop: 12.4, mud: 1.18, pressure: 142, updated: '2 мин назад',  note: 'Прошли пласт Ю1, готовимся к каротажу' },
  { id: 'BR-217-05', name: 'Берёзовская 5', field: 'Берёзовское', status: 'active', depth: 1892, target: 3200, op: 'Спуск ОК', rop: 0,    mud: 1.21, pressure: 98,  updated: '12 мин назад', note: 'Ожидание цементажа кондуктора' },
  { id: 'PR-009-12', name: 'Приобская 12',  field: 'Приобское',   status: 'warn',   depth: 2840, target: 2900, op: 'Каротаж', rop: 0,    mud: 1.14, pressure: 0,   updated: '1 ч назад',    note: 'Зона осложнений на 2810 м' },
  { id: 'PR-009-13', name: 'Приобская 13',  field: 'Приобское',   status: 'active', depth: 580,  target: 2700, op: 'Бурение', rop: 18.2, mud: 1.10, pressure: 76,  updated: '5 мин назад',  note: 'Кондуктор' },
  { id: 'VG-118-02', name: 'Ванкорская 2',  field: 'Ванкор',      status: 'idle',   depth: 3150, target: 3150, op: 'Освоение',rop: 0,    mud: 1.05, pressure: 0,   updated: 'вчера',        note: 'ГРП завершён, ожидание вызова притока' },
  { id: 'VG-118-07', name: 'Ванкорская 7',  field: 'Ванкор',      status: 'err',    depth: 2210, target: 3400, op: 'Прихват', rop: 0,    mud: 1.32, pressure: 220, updated: '47 мин назад', note: 'Прихват КНБК на 2210 м, расхаживание' },
  { id: 'SM-401-01', name: 'Самотлор 1',    field: 'Самотлор',    status: 'active', depth: 2640, target: 2800, op: 'Бурение', rop: 9.6,  mud: 1.16, pressure: 118, updated: '3 мин назад',  note: '—' },
  { id: 'YM-220-08', name: 'Ямбургская 8',  field: 'Ямбург',      status: 'active', depth: 1450, target: 4100, op: 'Бурение', rop: 14.7, mud: 1.12, pressure: 88,  updated: '8 мин назад',  note: 'Нормальный режим' },
  { id: 'KH-302-03', name: 'Харасавэй 3',   field: 'Харасавэй',   status: 'idle',   depth: 0,    target: 3600, op: 'Монтаж БУ',rop: 0,   mud: 0,    pressure: 0,   updated: '3 дня назад',  note: 'Подготовка площадки' },
]

export const FIELDS: Field[] = [
  { name: 'Берёзовское', count: 7,  color: 'ok' },
  { name: 'Приобское',   count: 12, color: 'info' },
  { name: 'Ванкор',      count: 4,  color: 'warn' },
  { name: 'Самотлор',    count: 9,  color: 'ok' },
  { name: 'Ямбург',      count: 3,  color: 'info' },
  { name: 'Харасавэй',   count: 2,  color: 'idle' },
]

export const RECENT: RecentItem[] = [
  { id: 'BR-217-04', title: 'Журнал — 28.04.2026',           kind: 'note' },
  { id: 'PR-009-12', title: 'Расчёт обсадной колонны',       kind: 'note' },
  { id: 'VG-118-07', title: 'Инцидент — прихват КНБК',       kind: 'incident' },
  { id: 'BR-217-04', title: 'GTI-log_smena_3.csv',           kind: 'file' },
  { id: 'SM-401-01', title: 'Программа бурения v4',          kind: 'note' },
]

export const ACTIVITY: ActivityItem[] = [
  { time: '14:32', who: 'А. Соколов', what: 'обновил заметку',        target: 'Журнал — 28.04.2026', well: 'BR-217-04' },
  { time: '14:18', who: 'система',    what: 'загрузила телеметрию',   target: 'GTI 14:00–14:15',     well: 'BR-217-04' },
  { time: '13:51', who: 'М. Орлова',  what: 'создала задачу',         target: 'Проверить ВЗД',       well: 'PR-009-12' },
  { time: '13:24', who: 'Д. Иванов',  what: 'прикрепил файл',         target: 'core_sample_2810.jpg',well: 'PR-009-12' },
  { time: '12:47', who: 'А. Соколов', what: 'закрыл инцидент',        target: 'Утечка на манифольде',well: 'SM-401-01' },
  { time: '11:55', who: 'система',    what: 'детектировала аномалию', target: 'Скачок СПО',          well: 'VG-118-07' },
]

export const TASKS: Task[] = [
  { id: 'T-184', title: 'Подготовить программу ГТИ для каротажа', well: 'BR-217-04', due: 'сегодня', priority: 'high', done: false },
  { id: 'T-183', title: 'Согласовать план КРС с заказчиком',       well: 'PR-009-12', due: '29 апр',  priority: 'med',  done: false },
  { id: 'T-182', title: 'Заказать долото PDC 215.9',               well: 'BR-217-05', due: '30 апр',  priority: 'med',  done: false },
  { id: 'T-181', title: 'Проверить параметры БР после ШГН',        well: 'SM-401-01', due: 'сегодня', priority: 'low',  done: true  },
  { id: 'T-180', title: 'Передать вахте ночь смену',               well: 'BR-217-04', due: 'вчера',   priority: 'low',  done: true  },
]

export const FILES: FileItem[] = [
  { name: 'GTI-log_smena_3.csv',     kind: 'csv',  size: '2.4 МБ',  date: '28.04', thumb: 'csv' },
  { name: 'Программа бурения v4.pdf',kind: 'pdf',  size: '4.1 МБ',  date: '26.04', thumb: 'pdf' },
  { name: 'core_sample_2810.jpg',    kind: 'image',size: '8.7 МБ',  date: '27.04', thumb: 'img' },
  { name: 'Геофизика_BR-217-04.las', kind: 'las',  size: '12.3 МБ', date: '25.04', thumb: 'las' },
  { name: 'Схема обвязки.dwg',       kind: 'dwg',  size: '1.8 МБ',  date: '20.04', thumb: 'dwg' },
  { name: 'Акт_цементажа.pdf',       kind: 'pdf',  size: '0.9 МБ',  date: '19.04', thumb: 'pdf' },
  { name: 'Расчёт_ОК.xlsx',          kind: 'xlsx', size: '0.4 МБ',  date: '15.04', thumb: 'xls' },
  { name: 'Фото-устье.jpg',          kind: 'image',size: '3.2 МБ',  date: '12.04', thumb: 'img' },
]

export const SEARCH_RESULTS: SearchResult[] = [
  { kind: 'well', title: 'Берёзовская 4',           snippet: 'BR-217-04 · Берёзовское · бурение, 3247 м' },
  { kind: 'note', title: 'Журнал — 28.04.2026',     snippet: '...прошли пласт <mark>Ю1</mark>, готовимся к каротажу...' },
  { kind: 'note', title: 'Расчёт обсадной колонны', snippet: '...для скважины <mark>Берёзовская</mark> 4 принят диаметр 245 мм...' },
  { kind: 'file', title: 'GTI-log_smena_3.csv',     snippet: 'телеметрия за смену 28.04, скважина BR-217-04' },
  { kind: 'task', title: 'Подготовить программу ГТИ',snippet: 'T-184 · до сегодня · BR-217-04' },
]
